import { render, staticRenderFns } from "./LicenceProduct.vue?vue&type=template&id=5181471e&"
import script from "./LicenceProduct.vue?vue&type=script&lang=js&"
export * from "./LicenceProduct.vue?vue&type=script&lang=js&"
import style0 from "./LicenceProduct.vue?vue&type=style&index=0&id=5181471e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports